import React from 'react';
import { AbsoluteFill, Sequence } from 'remotion';
import { ThemeSystemConfig } from '../../clipCreator/remotion/Components/Theme/Theme';
import { AspectRatio } from '../AspectRatio';
import { TimelineDefaults } from '../TimelineDefaults';
import { CaptionItem, CaptionItemImpl } from '../types';
import { LayerContainer } from './types';
import { AnimationHelpers } from '../helpers';
import { AdvancedCaptionContent } from '../types/caption';

export class CaptionLayerContainer implements LayerContainer {
    items: CaptionItem[];

    constructor(items: Omit<CaptionItem, 'render'>[]) {
        this.items = items.map(item => new CaptionItemImpl(item));
    }

    render(fps: number, theme: ThemeSystemConfig, aspectRatio: AspectRatio, defaults: TimelineDefaults, videoConfig?: { width: number; height: number }): React.ReactNode {
        return (
            <AbsoluteFill>
                {this.items.map(item => {
                    // Use the item's render method which creates its own sequence
                    // This ensures proper timing and frame context
                    return item.render(fps, theme, aspectRatio, defaults, videoConfig);
                })}
            </AbsoluteFill>
        );
    }
} 